<template>
  <!-- 媒体登録ダイアログ -->
  <v-dialog v-model="dialog" scrollable persistent width="1000px">
    <v-card :disabled="loginCheckLoading">
      <v-card-title>
        <span class="text-h5">媒体設定</span>
      </v-card-title>
      <v-card-text class="scrollable-content">
        <input type="hidden" v-model="item.id" />
        <ValidationObserver ref="observer">
          <h3>更新媒体名</h3>
          <div class="mt-2 mb-2"></div>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  prepend-icon="mdi-application-outline"
                  v-model="showSite.name"
                  readonly
                  success
                  name="name"
                  label="媒体名"
                  outlined
                  hide-details="false"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <div :class="snsFlg ? 'd-none' : 'mb-6'">
            <h3 v-show="!hpLink">ログイン設定</h3>
            <div v-show="!hpLink" class="mt-2 mb-2">
              媒体（サイト）のログインに関する情報を設定してください。
              <span v-show="!hpLink">
                <v-btn
                  text
                  color="primary"
                  class="font-weight-bold pa-1 d-inline"
                  :loading="loginCheckLoading"
                  :disabled="loginCheckLoading"
                  @click="checkLogin"
                  ><span v-html="loginCheckButtonText"> </span></v-btn
              ></span>
              <span
                class="text-blue"
                v-if="item.site_id == setting.cit2_fuzoku_fan_site_id"
              >
                <br />風俗CTIv2のスタッフ専用ログインURL、スタッフ名、パスワードを設定してください。
              </span>
            </div>
            <v-container v-show="!hpLink">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="ログイン画面のURL"
                    :rules="`${!hpLink ? 'required|' : ''}${
                      item.site_id == setting.cit2_fuzoku_fan_site_id
                        ? 'url_https_ctiv2'
                        : 'url'
                    }|max:300`"
                  >
                    <v-text-field
                      prepend-icon="mdi-cloud"
                      v-model="item.auth_url"
                      v-show="!urlHide"
                      :error-messages="errors"
                      :success="valid"
                      name="auth_url"
                      label="ログイン画面のURL"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    :name="shopLoginIdLabel"
                    :rules="`${!hpLink ? 'required|' : ''}max:100`"
                  >
                    <v-text-field
                      prepend-icon="mdi-account-outline"
                      v-model="item.loginid"
                      :error-messages="errors"
                      :success="valid"
                      name="auth_loginid"
                      :label="shopLoginIdLabel"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="パスワード"
                    :rules="`${!hpLink ? 'required|' : ''}max:100`"
                  >
                    <v-text-field
                      prepend-icon="mdi-lock"
                      v-model="item.password"
                      :error-messages="errors"
                      :success="valid"
                      name="auth_password"
                      label="パスワード"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" v-show="!shopGroupIdHide">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    :name="shopGroupIdLabel"
                    :rules="shopGroupIdHide ? 'max:100' : 'required|max:100'"
                  >
                    <v-text-field
                      prepend-icon="mdi-store"
                      v-model="item.shop_group_id"
                      v-show="!shopGroupIdHide"
                      :error-messages="errors"
                      :success="valid"
                      name="shop_group_id"
                      :label="shopGroupIdLabel"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-show="item.site_id == setting.cit2_fuzoku_fan_site_id"
                >
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="CTIv2モード"
                    :rules="`${
                      item.site_id == setting.cit2_fuzoku_fan_site_id
                        ? 'required'
                        : ''
                    }`"
                  >
                    <v-select
                      prepend-icon="mdi-cellphone-iphone"
                      v-model="item.cti_v2_mode"
                      :items="setting.cit_v2_mode_items"
                      :error-messages="errors"
                      :success="valid"
                      name="cti_v2_mode"
                      label="CTIv2の利用モード"
                      outlined
                    ></v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
            <h3 v-show="hpLink">ホームページ連携設定</h3>
            <div v-show="hpLink" class="mt-2 mb-2">
              ホームページを設定するドメインを指定してください。<br />
              <span class="text-blue"
                >過去に設定したドメインと同じドメインを再設定する場合、必ず過去の設定は削除しておいてください。同じドメインが二つ設定された場合、ホームページが正しく表示されない原因になります。</span
              >
            </div>
            <v-container v-show="hpLink">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="ホームページのドメイン"
                    :rules="`${hpLink ? 'required|' : ''}max:300|domain_check`"
                  >
                    <v-text-field
                      prepend-icon="mdi-cloud"
                      v-model="item.domain"
                      :error-messages="errors"
                      :success="valid"
                      name="domain"
                      label="ホームページのドメイン"
                      placeholder="https://は省略してください。例）example.com"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div :class="snsFlg ? 'mb-6' : 'd-none'">
            <h3>アカウント設定</h3>
            <div class="mt-2 mb-2">
              X連携管理画面にてXのアカウントと連携してください。
            </div>
          </div>
          <!-- PC用ツールのAPIキー -->
          <div
            v-show="
              item.id != 0 &&
              setting.yagent_target_site_ids.includes(Number(item.site_id))
            "
          >
            <h3>PC用ツールのAPIキー</h3>
            <div class="mt-2 mb-2">
              店舗PCにインストールするPC用ツールの認証用APIキーを生成します。生成後、表示された値を店舗担当者に共有してください。
            </div>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="info"
                    btn_block
                    @click-event="() => issueKey(setting.api_key_type_yagent)"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-key-plus</v-icon></template
                    >キー生成</general-button
                  >
                </v-col>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="error"
                    btn_block
                    @click-event="() => deleteKey(setting.api_key_type_yagent)"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-key-remove</v-icon></template
                    >キー削除</general-button
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    readonly
                    v-model="api_keys[setting.api_key_type_yagent].value"
                    :success="!!api_keys[setting.api_key_type_yagent].value"
                    label="PC用ツールのAPIキー"
                    :hint="
                      item.id == 0
                        ? `新規登録時は利用できません。`
                        : `キー生成ボタンで認証用のAPIキーが表示されます。`
                    "
                    persistent-hint
                    outlined
                    :disabled="item.id == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- PC用ツール検証 -->
          <div
            v-show="
              item.id != 0 &&
              setting.yagent_target_site_ids.includes(Number(item.site_id))
            "
          >
            <h3>PC用ツール検証</h3>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="info"
                    btn_block
                    @click-event="pingClient"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-lan-connect</v-icon></template
                    >通信確認</general-button
                  >
                </v-col>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="info"
                    btn_block
                    @click-event="collectLogs"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-download</v-icon></template
                    >ログ取得</general-button
                  >
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- キー生成機能は使用しない <div v-show="item.id != 0 && hpLink">
            <h3 id="title_head">ホームページ連携専用項目</h3>
            <div class="mt-2 mb-2">ホームページ連携に関連する項目です。</div>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="info"
                    btn_block
                    @click-event="() => issueKey(setting.api_key_type_hp)"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-key-plus</v-icon></template
                    >キー生成</general-button
                  >
                </v-col>
                <v-col cols="6" sm="4">
                  <general-button
                    btn_type="error"
                    btn_block
                    @click-event="() => deleteKey(setting.api_key_type_hp)"
                    :btn_disabled="item.id == 0"
                    ><template v-slot:icon
                      ><v-icon left>mdi-key-remove</v-icon></template
                    >キー削除</general-button
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    readonly
                    v-model="api_keys[setting.api_key_type_hp].value"
                    :success="true"
                    label="ホームページ連携用APIキー"
                    :hint="
                      item.id == 0
                        ? `新規登録時は利用できません。`
                        : `キー生成ボタンで連携用のAPIキーが表示されます。`
                    "
                    persistent-hint
                    outlined
                    :disabled="item.id == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </div> -->
          <h3>対応コンテンツ一覧</h3>
          <div class="mt-2 mb-2">
            下記コンテンツの更新に対応しています。更新しないコンテンツはチェックを外してください。<br />
            <span
              v-if="
                !setting.esutama_site_id.includes(Number(item.site_id)) &&
                !snsFlg
              "
            >
              ※スケジュールにチェックを入れておくと毎日6時30分～7時の間に、登録されているスケジュールで自動更新します。
            </span>
            <span v-else-if="!snsFlg" class="red--text">
              ※スケジュールを自動更新する際は、スケジュールにチェックを入れて保存し、スケジュール管理画面で<span
                class="font-weight-bold"
                >「エステ魂更新設定」</span
              >ボタンをクリックして時刻を設定して下さい。
            </span>
          </div>
          <v-data-table
            :headers="headers"
            :items="siteContents"
            item-key="site_content_id"
            :items-per-page="-1"
            :mobile-breakpoint="0"
            hide-default-footer
            dense
            show-select
            :single-select="false"
            v-model="selected"
            no-data-text="対応コンテンツがありません"
            @click:row="rowClick"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.site_content_name="{ item }">
              <span class="text-align-middle"
                >&nbsp;{{ item.site_content_name }}</span
              >
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.content_name="{ item }">
              <v-icon> {{ item.content_icon }} </v-icon
              ><span class="text-align-middle"
                >&nbsp;{{ item.content_name }}</span
              >
            </template>
          </v-data-table>
          <h3 class="mt-12">個別設定</h3>
          <div class="mt-2 mb-2">媒体個別の情報があれば入力してください。</div>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="メモ"
                  rules="max:1000"
                >
                  <v-text-field
                    prepend-icon="mdi-text-box"
                    v-model="item.memo"
                    :error-messages="errors"
                    :success="valid"
                    label="メモ"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" id="color-selector">
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="カラー"
                  rules="required"
                >
                  <v-text-field
                    prepend-icon="mdi-palette"
                    v-model="item.color"
                    hide-details
                    :error-messages="errors"
                    :success="valid"
                    label="カラー選択"
                    readonly
                    outlined
                  >
                    <template v-slot:append>
                      <v-menu
                        v-model="item.menu"
                        top
                        nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <div :style="swatchStyle(item)" v-on="on"></div>
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker
                              v-model="item.color"
                              flat
                              show-swatches
                              mode="hexa"
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>

          <div v-show="!hpLink">
            <h3>個別のサーバ設定</h3>
            <div class="mt-2 mb-2">
              共用サーバを使用せず、個別サーバを経由して媒体を更新します。<span
                class="red--text"
                >運営管理画面のみ、編集可能。</span
              >
            </div>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="個別サーバ"
                    rules="ipv4port"
                  >
                    <v-text-field
                      prepend-icon="mdi-server"
                      v-model="item.proxy_server"
                      :error-messages="errors"
                      :success="valid"
                      :readonly="false"
                      label="個別サーバ"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row justify="end">
            <v-col cols="6" sm="3">
              <general-button
                btn_color="gray"
                btn_block
                @click-event="cancelDialog"
                ><template v-slot:icon
                  ><v-icon left>mdi-close-circle</v-icon></template
                >キャンセル</general-button
              >
            </v-col>
            <v-col cols="6" sm="3">
              <general-button btn_type="info" btn_block @click-event="onSubmit"
                ><template v-slot:icon
                  ><v-icon left>mdi-content-save</v-icon></template
                >保存</general-button
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reactive, toRefs, defineComponent } from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import { isYagentClientConnected, isYagentTargetSite } from "@/utils/yagent";

export default defineComponent({
  setup(props, ctx) {
    const shopSitesRepository = repositoryFactory.get("shopSites");
    const shopSiteContentsRepository =
      repositoryFactory.get("shopSiteContents");
    const sitesRepository = repositoryFactory.get("sites");
    const synchroRepository = repositoryFactory.get("synchro");
    const updateContentsRepository = repositoryFactory.get("updateContents");
    const OpenRepository = repositoryFactory.get("open");
    const ShopSiteApiKeysRepository = repositoryFactory.get("shopSiteApiKeys");
    const YagentRepository = repositoryFactory.get("yagent");

    const state = reactive({
      showSite: [],
      dialog: false, // ダイアログ表示用
      urlHide: false,
      hpLink: false,
      shopLoginIdLabel: "ログインID",
      shopGroupIdLabel: "",
      shopGroupIdHide: false,
      item: {
        id: 0,
        site_id: 0,
        default_site_id: 0,
        loginid: "",
        password: "",
        auth_url: "",
        memo: "",
        color: "",
        mask: "!#XXXXXXXX",
        menu: false,
        proxy_server: null,
        category: "",
        shop_group_id: "",
        cti_v2_mode: "", // 風俗CTIv2のモード用(pc/sp)
        sort: 9999,
        domain: "",
      },
      loginCheckLoading: false,
      loginCheckButtonText: "ログイン確認",
      siteContents: [],
      headers: [
        {
          text: "",
          value: "data-table-select",
          width: 30,
        },
        {
          text: "コンテンツ名",
          value: "site_content_name",
          sortable: false,
          class: "td_site_content_name",
        },
        {
          text: "タイプ",
          value: "content_name",
          sortable: false,
          class: "td_content_name",
        },
        { text: "タイトル", value: "title_limit", sortable: false },
        { text: "内容　　", value: "body_limit", sortable: false },
        { text: "最低間隔", value: "min_interval", sortable: false },
      ],
      selected: [],
      // key_type ごとの API キー値を保持する（HP / yagent / 将来の拡張用）
      api_keys: {
        [setting.api_key_type_hp]: { value: "" },
        [setting.api_key_type_yagent]: { value: "" },
      },
      // SNS関連の変数
      snsFlg: false,
      // linkProcess: false,
      // linkDeleteProcess: false,
      // snsloading: false,
    });

    // 編集
    const showDialog = async (editItems) => {
      await store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // サイトの情報を取得する
      state.siteContents.splice(0);
      state.selected.splice(0);
      await sitesRepository
        .admin_get_with_content(editItems.site_id)
        .then((response) => {
          if (response.data) {
            state.showSite = response.data;
            if (response.data.content) {
              Object.keys(response.data.content).forEach(function (key) {
                const name_option = response.data.content[key].is_update
                  ? ""
                  : "（取込のみ）";
                const item = {
                  "site_content_id": response.data.content[key].id,
                  "site_content_name":
                    response.data.content[key].name + name_option,
                  "content_icon": response.data.content[key].content_icon,
                  "content_name": response.data.content[key].content_name,
                  "title_limit":
                    response.data.content[key].title_limit == 0
                      ? "-"
                      : response.data.content[key].title_limit + "文字まで",
                  "body_limit":
                    response.data.content[key].body_limit == 0
                      ? "-"
                      : response.data.content[key].body_limit + "文字まで",
                  "min_interval":
                    response.data.content[key].min_interval == 0
                      ? "-"
                      : response.data.content[key].min_interval + "分",
                  "content_enable": true,
                };
                state.siteContents.push(item);
                if (editItems.id == 0) {
                  state.selected.push(item);
                }
              });
            }
          }
        })
        .catch((error) => {
          throw (
            "ERROR:shopSiteDialog.vue/init sitesRepository.list (" + error + ")"
          );
        });

      // 店舗媒体コンテンツの情報を取得する
      if (editItems.id != 0) {
        const params = {
          shop_site_id: editItems.id,
        };
        state.selected.splice(0);
        await shopSiteContentsRepository
          .admin_list_shopsite(params)
          .then((response) => {
            if (response.data) {
              Object.keys(response.data).forEach(function (key) {
                if (response.data[key].is_enable) {
                  const item = state.siteContents.find(function (element) {
                    return (
                      element.site_content_id ==
                      response.data[key].site_content_id
                    );
                  });
                  state.selected.push(item);
                }
              });
            }
          })
          .catch((error) => {
            throw (
              "ERROR:shopSiteDialog.vue/init shopSiteContentsRepository.list (" +
              error +
              ")"
            );
          });
      }

      // SNS関連か判定
      if (setting.x_site_ids.includes(editItems.site_id)) {
        state.snsFlg = true;
      } else {
        state.snsFlg = false;
      }

      // ダイアログにアイテムを格納
      state.item.id = editItems.id;
      state.item.shop_id = editItems.shop_id;
      state.item.site_id = editItems.site_id;
      state.item.loginid = editItems.loginid;
      state.item.password = editItems.password;
      state.item.auth_url = editItems.auth_url;
      state.item.memo = editItems.memo;
      state.item.color = editItems.color;
      state.item.shop_group_id = editItems.shop_group_id;
      state.item.cti_v2_mode = editItems.cti_v2_mode;
      // // 新規かつエステラブの時、PROXYサーバをあらかじめ設定しておく(このコードは廃止)
      // if (editItems.id == 0 && editItems.site_id == setting.eslove_site_id) {
      //   state.item.proxy_server = process.env.VUE_APP_ESLOVE_PROXY;
      // } else {
      //   state.item.proxy_server = editItems.proxy_server;
      // }
      state.item.category = editItems.category;
      state.item.sort = editItems.sort;
      state.item.domain = editItems.domain;

      // default_auth_urlが設定されている媒体は、URL入力欄を非表示にする
      if (state.showSite.default_auth_url) {
        state.urlHide = true;
      } else {
        state.urlHide = false;
      }
      // 全 key_type のキャッシュをリセット
      Object.keys(state.api_keys).forEach((k) => {
        state.api_keys[k].value = "";
      });

      // ホームページ連携で更新の場合は HP 用 API キーを取得
      state.hpLink = state.item.category == setting.site_category_hp_link;
      if (state.hpLink) {
        state.urlHide = false;
        if (editItems.id != 0) {
          state.api_keys[setting.api_key_type_hp].value = await fetchApiKey(
            editItems.id,
            setting.api_key_type_hp
          );
        }
      }

      // yagent 対象媒体の場合は yagent 用 APIキーを取得
      if (
        editItems.id != 0 &&
        setting.yagent_target_site_ids.includes(Number(editItems.site_id))
      ) {
        state.api_keys[setting.api_key_type_yagent].value = await fetchApiKey(
          editItems.id,
          setting.api_key_type_yagent
        );
      }

      // サイトIDに合わせて利用者IDを表示にする
      if (editItems.site_id == setting.venty_site_id) {
        state.shopGroupIdLabel = "利用者ID";
        state.shopGroupIdHide = false;
      } else if (editItems.site_id == setting.caskan_site_id) {
        state.shopGroupIdLabel = "店舗ID";
        state.shopGroupIdHide = false;
      } else if (editItems.site_id == setting.cit2_fuzoku_fan_site_id) {
        state.shopLoginIdLabel = "スタッフ名";
        state.shopGroupIdHide = true;
        if (editItems.id == 0) {
          state.item.cti_v2_mode = setting.cti_v2_mode_pc; // 風俗CTIv2のモードは新規登録の際はPCモードをデフォルトにする
        }
      } else {
        state.shopLoginIdLabel = "ログインID";
        state.shopGroupIdHide = true;
      }

      // ダイアログ開く
      state.dialog = true;
      scrollReset();

      // ローディング非表示
      await store.dispatch("loadingIcon/hideIcon");
    };

    // 保存処理
    const onSubmit = async () => {
      // 入力チェック（SNSの時は、チェックしない）
      let isValid = true;
      if (!state.snsFlg) {
        isValid = await ctx.refs.observer.validate();
      }

      console.log("shopGroupIdHide", state.shopGroupIdHide, "isValid", isValid);

      if (!isValid) {
        // エラー処理
      } else {
        let logincheck = { status: true, skipped: false };
        if (!state.snsFlg && !isYagentTargetSite(state.item.site_id)) {
          // ログインチェック (SNS / yagent 対象媒体の時は、チェックしない)
          // yagent 対象媒体はサーバ側でログイン不可なため、保存時のチェックを行わない
          logincheck = await checkLogin();
        }
        if (logincheck.skipped) {
          if (
            !window.confirm(
              "PC用ツール未接続のためログイン確認できません。保存してよろしいですか？"
            )
          ) {
            return false;
          }
        } else if (logincheck.status) {
          if (!window.confirm("保存してよろしいですか？")) {
            return false;
          }
        } else {
          if (
            !window.confirm(
              "媒体にログインできませんでした。保存してよろしいですか？"
            )
          ) {
            return false;
          }
        }
        store.dispatch("loadingIcon/showIcon"); // ローディング表示
        // 新規か更新か
        if (state.item.id == 0) {
          // 新規 データ追加処理(店舗媒体)
          let config = {
            "memo": state.item.memo,
            "color": state.item.color,
          };
          if (!state.shopGroupIdHide) {
            config.shop_group_id = state.item.shop_group_id;
          }
          if (state.item.site_id == setting.cit2_fuzoku_fan_site_id) {
            config.cti_v2_mode = state.item.cti_v2_mode;
          }
          const params = {
            shop_id: state.item.shop_id,
            site_id: state.item.site_id,
            auth_url: state.item.auth_url,
            loginid: state.item.loginid, // snsの時は、アカウントのIDが入れる
            password: state.item.password, // snsの時は、アカウントのトークンが入れる
            config: JSON.stringify(config),
            proxy_server: state.item.proxy_server,
            sort: state.item.sort,
            domain: state.item.domain,
          };
          await shopSitesRepository
            .admin_create(params)
            .then((response) => {
              if (response.data) {
                // データ追加OK
                state.item.id = response.data.id; // idをセット
                ctx.refs.observer.reset(); // 入力エラー表示クリア
              }
            })
            .catch((error) => {
              throw (
                "ERROR:ShopSiteDialog.vue/onSubmit shopSitesRepository.create (" +
                error +
                ")"
              );
            });

          // エステ魂スケジュール機能の廃止に伴い、以下の処理はコメントアウト
          // // エステ魂の場合に限り、スケジュールの自動更新設定を実行しておく
          // await saveEstamaSchedule();
        } else {
          // 更新
          let config = {
            "memo": state.item.memo,
            "color": state.item.color,
          };
          if (!state.shopGroupIdHide) {
            config.shop_group_id = state.item.shop_group_id;
          }
          if (state.item.site_id == setting.cit2_fuzoku_fan_site_id) {
            config.cti_v2_mode = state.item.cti_v2_mode;
          }
          const params = {
            id: state.item.id,
            shop_id: state.item.shop_id,
            site_id: state.item.site_id,
            loginid: state.item.loginid,
            password: state.item.password,
            auth_url: state.item.auth_url,
            config: JSON.stringify(config),
            proxy_server: state.item.proxy_server,
            sort: state.item.sort,
            domain: state.item.domain,
          };
          // データ更新処理
          await shopSitesRepository
            .admin_update(params)
            .then((response) => {
              if (response.data) {
                // 更新OK
                ctx.refs.observer.reset(); // 入力エラー表示クリア
              }
            })
            .catch((error) => {
              throw (
                "ERROR:ShopSiteDialog.vue/onSubmit shopSitesRepository.update (" +
                error +
                ")"
              );
            });
        }
        // shop_site_contentsテーブル更新
        await saveShopSiteContents();

        // 保存されたshop_site.idをスケジュール自動更新設定に追加
        await shopSitesRepository.admin_update_auto_synchro_schedule({
          shop_id: state.item.shop_id,
          shop_site_id: state.item.id, // 新規追加または更新されたshop_site.id
          site_id: state.item.site_id,
        });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");

        cancelDialog();
        ctx.emit("save");
      }
    };

    const saveShopSiteContents = async () => {
      // shop_site_contentsテーブル更新
      const site_content_ids = [];
      for (let i = 0; i < state.selected.length; i++) {
        site_content_ids.push(state.selected[i].site_content_id);
      }
      const params = {
        shop_site_id: state.item.id,
        site_content_id: site_content_ids,
      };
      await shopSiteContentsRepository
        .admin_save_list(params)
        .then((response) => {
          if (response.data) {
            // 更新OK
            if (!response.data.result) {
              alert("店舗媒体コンテンツの保存に失敗しました。");
              return false;
            }
          }
        })
        .catch((error) => {
          throw (
            "ERROR:shopSiteContentsRepository.admin_save_list (" + error + ")"
          );
        });
    };

    const saveEstamaSchedule = async () => {
      // エステ魂の場合に限り、スケジュールの自動更新設定を実行しておく
      if (setting.esutama_site_id.includes(Number(state.item.site_id))) {
        await updateContentsRepository
          .admin_save_esutama_schedule({
            shop_id: state.item.shop_id,
          })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:ShopSiteDialog.vue/onSubmit updateContentsRepository.save_esutama_schedule (" +
              error +
              ")"
            );
          });
      }
    };

    // ダイアログキャンセルボタン
    const cancelDialog = () => {
      ctx.refs.observer.reset(); // 入力エラー表示クリア
      state.dialog = false;
    };

    // ログインチェック
    const checkLogin = async () => {
      // ホームページ連携の場合は、ログインチェックしない
      if (state.hpLink) {
        return { status: true, skipped: false };
      }
      // 入力チェック
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        // エラー処理
        return { status: false, skipped: false };
      }
      // ログインチェック中は、ボタン・カードをdisabledに。
      state.loginCheckLoading = true;
      state.loginCheckButtonText = "確認中";
      // ログインチェック処理
      let config = {
        "memo": state.item.memo,
        "color": state.item.color,
      };
      if (!state.shopGroupIdHide) {
        config.shop_group_id = state.item.shop_group_id;
      }
      if (state.item.site_id == setting.cit2_fuzoku_fan_site_id) {
        config.cti_v2_mode = state.item.cti_v2_mode;
      }
      const params = {
        shop_id: state.item.shop_id,
        site_id: state.item.site_id,
        auth_url: state.item.auth_url,
        loginid: state.item.loginid,
        password: state.item.password,
        shop_site_id: state.item.id,
        proxy_server: state.item.proxy_server,
        config: JSON.stringify(config),
      };
      const result = await synchroRepository
        .admin_login_check(params)
        .then((response) => {
          if (response.data.skipped) {
            // PC用ツール未接続 / APIキー未発行 等で確認自体がスキップされた
            state.loginCheckButtonText =
              "<span style='color:red'>PC用ツール未接続</span>";
            setTimeout(() => {
              state.loginCheckButtonText = "ログイン確認";
            }, 5000);
            return { status: false, skipped: true };
          }
          if (response.data.status) {
            // 確認OK
            state.loginCheckButtonText =
              "<span style='color:blue'>確認できました</span>";
            setTimeout(() => {
              state.loginCheckButtonText = "ログイン確認";
            }, 5000);
            return { status: true, skipped: false };
          }
          // 確認NG
          state.loginCheckButtonText =
            "<span style='color:red'>ログインできません</span>";
          setTimeout(() => {
            state.loginCheckButtonText = "ログイン確認";
          }, 5000);
          return { status: false, skipped: false };
        })
        .catch((error) => {
          throw (
            "ERROR:ShopSite.vue/checkLogin synchroRepository.login_check (" +
            error +
            ")"
          );
        });
      // 結果
      state.loginCheckLoading = false;
      return result;
    };

    const swatchStyle = (item) => {
      return {
        backgroundColor: item.color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: item.menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    };

    const scrollReset = () => {
      setTimeout(() => {
        document.getElementsByClassName("scrollable-content")[0].scrollTop = 0;
        // document.querySelector(".scrollable-content").scroll(0, 0);
        // console.log("sReset");
      }, 200);
    };

    const rowClick = (item, row) => {
      row.select(!row.isSelected);
    };

    // shop_site_id × key_type の既存 APIキーを取得（未発行時は空文字）
    const fetchApiKey = async (shopSiteId, keyType) => {
      return ShopSiteApiKeysRepository.admin_get_by_keytype(shopSiteId, keyType)
        .then((response) => (response.data ? response.data.value : ""))
        .catch(() => "");
    };

    // key_type を指定して APIキーを発行（再発行は上書き）
    const issueKey = async (keyType) => {
      if (
        !window.confirm(
          "APIキーを生成します。よろしいですか？\n※この操作で以前に生成したAPIキーは上書きされます(無効になります)。"
        )
      ) {
        return false;
      }
      await OpenRepository.admin_create_api_key(state.item.id, keyType)
        .then((response) => {
          if (response.data) {
            if (response.data.result) {
              state.api_keys[keyType].value = response.data.api_key;
            } else {
              alert(response.data.message);
              state.api_keys[keyType].value = "";
            }
          }
        })
        .catch((error) => {
          throw `ERROR:shopSiteDialog.vue/issueKey (keyType=${keyType}): ${error}`;
        });
    };

    // PC用ツールとの通信確認（SSE 経由で ping を送信し、クライアント到達可否を判定）
    const pingClient = async () => {
      if (state.item.id == 0) return;
      store.dispatch("loadingIcon/showIcon");
      try {
        if (await isYagentClientConnected(state.item.id)) {
          alert("PC用ツールとの通信確認に成功しました。");
        }
        // 未接続時は isYagentClientConnected 内で alert 済み
      } catch (error) {
        alert("通信確認に失敗しました。");
      } finally {
        store.dispatch("loadingIcon/hideIcon");
      }
    };

    // PC用ツールのログを取得（事前に疎通確認 → クライアントに収集要求 → zip ダウンロード）
    const collectLogs = async () => {
      if (state.item.id == 0) return;
      store.dispatch("loadingIcon/showIcon");
      try {
        // 先に疎通確認。未接続なら標準 alert を表示して中断
        if (!(await isYagentClientConnected(state.item.id))) return;
        const response = await YagentRepository.admin_collect_logs(
          state.item.id
        );
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const ts = new Date()
          .toISOString()
          .replace(/[-:T.]/g, "")
          .slice(0, 14);
        const a = document.createElement("a");
        a.href = url;
        a.download = `yagent_logs_${state.item.id}_${ts}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        const status = error?.response?.status;
        if (status === 408) {
          alert("クライアントから応答がありませんでした。再度お試しください。");
        } else {
          alert("ログ取得に失敗しました。");
        }
      } finally {
        store.dispatch("loadingIcon/hideIcon");
      }
    };

    // key_type を指定して APIキーを削除
    const deleteKey = async (keyType) => {
      if (
        !window.confirm(
          "この媒体で生成されていたAPIキーを直ちに削除します。よろしいですか？(保存しなくてもAPIキーは削除されます。)"
        )
      ) {
        return false;
      }
      await ShopSiteApiKeysRepository.admin_delete_by_keytype(
        state.item.id,
        keyType
      )
        .then((response) => {
          if (response.data) {
            state.api_keys[keyType].value = "";
            alert("APIキーを削除しました。");
          }
        })
        .catch((error) => {
          throw `ERROR:shopSiteDialog.vue/deleteKey (keyType=${keyType}): ${error}`;
        });
    };

    // 運営側の管理画面ではSNS連携操作は対応しない
    // const snsLogin = async () => {
    //   console.log("SNS Login");
    //   state.linkProcess = true;

    //   // shop_siteが未保存の場合、先に保存しておく
    //   if (state.item.id == 0) {
    //     const preSaveResult = await onSubmit(true);
    //     if (!preSaveResult) {
    //       return false;
    //     }
    //   }

    //   // URLを取得する
    //   const params = {
    //     shop_id: store.getters["shops/currentShop"].id,
    //     site_id: state.item.site_id,
    //     auth_url: state.item.auth_url,
    //     loginid: state.item.loginid,
    //     password: state.item.password,
    //     shop_site_id: state.item.id,
    //     proxy_server: state.item.proxy_server,
    //     config: JSON.stringify({
    //       "memo": state.item.memo,
    //       "color": state.item.color,
    //       "sns_user_name": state.item.sns_user_name,
    //       "sns_user_icon": state.item.sns_user_icon,
    //       "sns_link_flg": state.item.sns_link_flg,
    //     }),
    //   };
    //   const res = await synchroRepository
    //     .get_authorization_url(params)
    //     .then((response) => {
    //       console.log("response", response);
    //       return response.data;
    //     })
    //     .catch((error) => {
    //       state.linkProcess = false;
    //       throw (
    //         "ERROR:synchroRepository.sync_get_authorization_url (" + error + ")"
    //       );
    //     });

    //   if (res.status) {
    //     // ブラウザでURLを開く
    //     console.log("URL", res.data.auth_url);
    //     window.location.href = res.data.auth_url;
    //   } else {
    //     alert(res.message);
    //   }

    //   state.linkProcess = false;
    // };

    // const snsCancel = () => {
    //   state.linkProcess = false;
    //   console.log("SNS Cancel");
    // };

    // const snsDelete = async () => {
    //   state.linkDeleteProcess = true;

    //   if (
    //     !window.confirm(
    //       "連携を解除してよろしいですか？\n※保存ボタンに関係なく、ただちに連携は解除されます。"
    //     )
    //   ) {
    //     state.linkDeleteProcess = false;
    //     return false;
    //   }
    //   // 連携を解除する
    //   const params = {
    //     shop_id: store.getters["shops/currentShop"].id,
    //     site_id: state.item.site_id,
    //     auth_url: state.item.auth_url,
    //     loginid: state.item.loginid,
    //     password: state.item.password,
    //     shop_site_id: state.item.id,
    //   };
    //   const res = await synchroRepository
    //     .sns_delete_link(params)
    //     .then((response) => {
    //       return response.data;
    //     })
    //     .catch((error) => {
    //       state.linkProcess = false;
    //       throw "ERROR:synchroRepository.sns_delete_link (" + error + ")";
    //     });
    //   // state.item.sns_user_name = "";
    //   // state.item.sns_user_icon = "";
    //   // state.item.sns_link_flg = false;

    //   // 媒体情報を更新
    //   ctx.emit("refresh");

    //   state.linkDeleteProcess = false;
    // };

    // const snsUpdateUserProfile = async () => {
    //   state.snsloading = true;

    //   // shop_siteが未保存の場合、先に保存しておく
    //   if (state.item.id == 0) {
    //     const preSaveResult = await onSubmit(true);
    //     if (!preSaveResult) {
    //       return false;
    //     }
    //   }

    //   // ユーザ情報を更新する
    //   const params = {
    //     shop_id: store.getters["shops/currentShop"].id,
    //     site_id: state.item.site_id,
    //     auth_url: state.item.auth_url,
    //     loginid: state.item.loginid,
    //     password: state.item.password,
    //     shop_site_id: state.item.id,
    //   };
    //   const res = await synchroRepository
    //     .sns_update_user_profile(params)
    //     .then((response) => {
    //       return response.data;
    //     })
    //     .catch((error) => {
    //       state.snsloading = false;
    //       alert(error.message);
    //       throw (
    //         "ERROR:synchroRepository.sns_update_user_profile (" + error + ")"
    //       );
    //     });

    //   if (res.status) {
    //     state.item.loginid = res.data.user.loginid;
    //     // state.item.sns_user_name = res.data.user.sns_user_name;
    //     // state.item.sns_user_icon = res.data.user.sns_user_icon;
    //     // state.item.sns_link_flg = res.data.user.sns_link_flg;
    //     // 媒体情報を更新
    //     ctx.emit("refresh");
    //   } else {
    //     alert(res.message);
    //   }

    //   state.snsloading = false;
    // };

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      onSubmit,
      cancelDialog,
      showDialog,
      checkLogin,
      swatchStyle,
      scrollReset,
      rowClick,
      issueKey,
      deleteKey,
      pingClient,
      collectLogs,
      // snsLogin, 非対応とする
      // snsDelete,
      // snsCancel,
      // snsUpdateUserProfile,
    };
  },
});
</script>

<style scoped>
::v-deep #color-selector .v-input__append-inner {
  margin-top: 13px;
}
.edit_area {
  cursor: pointer;
}
::v-deep .td_content_name {
  width: 160px;
}
::v-deep .td_site_content_name {
  min-width: 160px;
}
</style>
